import createReactContext from '@ant-design/create-react-context';
export var TreeContext = createReactContext(null);


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-tree/es/contextTypes.js
// module id = 588
// module chunks = 0